import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import AnnouncementBanner from "./AnnouncementBanner";

const PublicLayout = () => {
  return (
    <div className="min-h-screen">
      <AnnouncementBanner />
      <Outlet />
      <Footer />
    </div>
  );
};

export default PublicLayout;
